import { all, call, put, takeLatest } from "redux-saga/effects";

import { ApiManager } from "services/api";

import { ApplicationSettingsActionNames, ApplicationSettingsActions } from "./actions";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* fetchSettings() {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.applicationSettingsApi.fetch);
  if (response.result) {
    yield put(ApplicationSettingsActions.fetchSuccess(response.result));
  } else {
    yield put(ApplicationSettingsActions.fetchFailure({ error: response.error }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* applicationSettingsSaga() {
  yield all([takeLatest(ApplicationSettingsActionNames.FETCH_APPLICATION_SETTINGS_REQUEST, fetchSettings)]);
}
